import {string, type} from 'io-ts';
import {HttpClient, POST, expectOneOf} from '~/library/network-facade';
import {UserStatusIoTs} from '../model/UserStatus';

const KYCStatusResponse = type({
    status: string,
    user: type({
        status: UserStatusIoTs,
    }),
});

export const updateKYCStatus = (http: HttpClient, status: UserStatusTransaction) => {
    return http('v1/on_boarding/status', POST({status})).then(
        expectOneOf({
            200: KYCStatusResponse,
            401: null,
        })
    );
};

/**
 * @see https://jira.raison.digital/browse/RAISON-5881
 */
export const resetKYCStatus = (http: HttpClient) => {
    return http('v1/on_boarding/reset', POST()).then(
        expectOneOf({
            200: type({
                status: UserStatusIoTs,
            }),
            401: null,
        })
    );
};

/**
 * This is a subset of a larger transaction type.
 *
 * Source of truth: https://gitlab.raison.digital/raison/rest-api/-/blob/master/config/packages/workflow/user.yaml?ref_type=heads#L70
 */
type UserStatusTransaction = 'start_kyc' | 'finish_kyc' | 'reset_stuck';
